import { faBars, faEnvelope, faPhone, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link } from "react-router-dom";
import logo from '../../img/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav>
        <div className='logo'>
         <Link to="/"><img src={logo} alt="Logo" /></Link>
        </div>
        <div className='local'>
          <div className='local2'>
            <div className='contact-info'>
              <h5>
                <a href='tel:7714050996'>
                  <FontAwesomeIcon className='io' icon={faPhone} />
                  <span> CALL: 07714050996</span>
                </a>
              </h5>
              <h5><span>|</span></h5>
              <h5>
                <a href='mailto:pooja@godriwala.com'>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>Email: pooja@godriwala.com</span>
                </a>
              </h5>
            </div>
          </div>
          <div>
            <div className='menu-icon' onClick={toggleMenu}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} color='#fff' />
            </div>
            <div className={`menu ${isMenuOpen ? 'open' : ''}`}>
              <ul>
                <li><Link to='/' onClick={closeMenu}>HOME</Link></li>
                <li><Link to='/about' onClick={closeMenu}>ABOUT</Link></li>
                <li><Link to='/product' onClick={closeMenu}>PRODUCT</Link></li>
                <li><Link to='/customer' onClick={closeMenu}>CATALOGUE</Link></li>
                <li><Link to='/contact' onClick={closeMenu}>CONTACT US</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
